var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("choose-a-field")))]),
      _c(
        "w-card-content",
        [
          _c("app-column-select", {
            attrs: {
              "is-filter": "",
              "ignored-fields": _vm.ignoredFields,
              model: _vm.model,
            },
            model: {
              value: _vm.selectedColumn,
              callback: function ($$v) {
                _vm.selectedColumn = $$v
              },
              expression: "selectedColumn",
            },
          }),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.selectedColumn == "" },
              on: {
                click: function ($event) {
                  return _vm.add()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.add")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }